export default "__VITE_ASSET__CTwOMgCL__"